<h4 nz-typography>Channel Details</h4>
<form nz-form nzLayout="vertical" [formGroup]="activationChannelForm">
  <nz-form-item>
    <nz-form-label [nzRequired]="true" nzFor="name" class="nfl-form-label">Activation Channel Name</nz-form-label>
    <nz-form-control [nzErrorTip]="nameErrorTemplate">
      <input
        nz-input
        formControlName="name"
        id="name"
        placeholder="Activation Channel Name"
        appTrimFormInput
        maxlength="100"
      />
    </nz-form-control>
  </nz-form-item>
  <ng-template #nameErrorTemplate let-control>
    <div *ngIf="control?.errors?.['required']">Please enter the Activation Channel Name</div>
    <div *ngIf="control?.errors?.['minlength']">
      Activation Channel Name must be at least
      {{ control?.errors?.['minlength'].requiredLength }} characters long.
    </div>
    <div *ngIf="control?.errors?.['maxlength']">
      Activation Channel Name cannot exceed
      {{ control?.errors?.['maxlength'].requiredLength }} characters.
    </div>
    <div *ngIf="control?.errors?.['pattern']">
      Activation Channel Name should not contain any special characters and should have at least one alphabet.
    </div>
  </ng-template>

  <nz-form-item>
    <nz-form-label [nzRequired]="true" nzFor="channelType" class="nfl-form-label">Channel Type</nz-form-label>
    <nz-form-control nzErrorTip="Channel Type is required">
      <nz-select [nzDisabled]="isEdit" nzPlaceHolder="Channel Type" formControlName="channelType" id="channelType">
        <nz-option
          [nzLabel]="type.name"
          [nzValue]="type.value"
          *ngFor="let type of channelType; index as i"
        ></nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item nz-col nzSpan="24">
    <nz-form-label [nzRequired]="true" nzFor="description" class="nfl-form-label">Channel Description</nz-form-label>
    <nz-form-control [nzErrorTip]="descriptionErrorTemplate">
      <textarea
        appTrimFormInput
        id="description"
        nz-input
        formControlName="description"
        placeholder="Channel Description"
        [nzAutosize]="{ minRows: 2, maxRows: 6 }"
        maxlength="500"
      ></textarea>
    </nz-form-control>
  </nz-form-item>
  <ng-template #descriptionErrorTemplate let-control>
    <div *ngIf="control?.errors?.['required']">Please enter the Channel Description.</div>
    <div *ngIf="control?.errors?.['maxlength']">
      Channel Description cannot exceed
      {{ control?.errors?.['maxlength'].requiredLength }} characters.
    </div>
    <div *ngIf="control?.errors?.['pattern']">Channel Description should contain at least one alphabet</div>
  </ng-template>
  <nz-divider></nz-divider>
  <h4 nz-typography>Channel Credentials Details</h4>

  <!-- META Channel Credentials - with form control and form group -->
  <ng-container *ngIf="activationChannelForm.get('channelType')?.value === 'META'">
    <ng-container formGroupName="channelSecrets" *ngIf="!channelId || isResetCredentials; else hashedMetaContainer">
      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="appId" class="nfl-form-label">App ID</nz-form-label>
        <nz-form-control [nzErrorTip]="appIdErrorTemplate">
          <input nz-input id="appId" formControlName="appId" placeholder="App ID" />
        </nz-form-control>
      </nz-form-item>
      <ng-template #appIdErrorTemplate let-control>
        <div *ngIf="appIdFormControl?.errors?.['required']">Please enter the App ID.</div>
        <div *ngIf="appIdFormControl?.errors?.['pattern']">App ID only accepts numeric values</div>
      </ng-template>

      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="appSecret" class="nfl-form-label">App Secret</nz-form-label>

        <nz-form-control [nzErrorTip]="appSecretErrorTemplate">
          <nz-input-group [nzSuffix]="secretTemplate">
            <input
              nz-input
              id="appSecret"
              [type]="secretVisible ? 'text' : 'password'"
              formControlName="appSecret"
              placeholder="App Secret"
            />
          </nz-input-group>
          <ng-template #secretTemplate>
            <i nz-icon [nzType]="secretVisible ? 'eye-invisible' : 'eye'" (click)="secretVisible = !secretVisible"></i>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <ng-template #appSecretErrorTemplate let-control>
        <div *ngIf="appSecretFormControl?.errors?.['required']">Please enter the App Secret.</div>
        <div *ngIf="appSecretFormControl?.errors?.['pattern']">App Secret must not contain spaces</div>
      </ng-template>

      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="appToken" class="nfl-form-label">App Access Token</nz-form-label>
        <nz-form-control [nzErrorTip]="appAccessTokenErrorTemplate">
          <nz-input-group [nzSuffix]="tokenTemplate">
            <textarea
              nz-input
              id="appToken"
              formControlName="appAccessToken"
              placeholder="Access Token"
              [nzAutosize]="{ minRows: 2, maxRows: 6 }"
              maxlength="500"
              [class.masked]="!tokenVisible"
            ></textarea>
          </nz-input-group>
          <ng-template #tokenTemplate>
            <i nz-icon [nzType]="tokenVisible ? 'eye-invisible' : 'eye'" (click)="tokenVisible = !tokenVisible"></i>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <ng-template #appAccessTokenErrorTemplate let-control>
        <div *ngIf="appAccessTokenFormControl?.errors?.['required']">Please enter the App Access Token.</div>
        <div *ngIf="appAccessTokenFormControl?.errors?.['pattern']">App Access Token must not contain spaces</div>
      </ng-template>

      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="adAccountId" class="nfl-form-label">Ad Account ID</nz-form-label>
        <nz-form-control [nzErrorTip]="adAccountIdErrorTemplate">
          <input nz-input id="adAccountId" formControlName="adAccountId" placeholder="Ad Account ID" />
        </nz-form-control>
      </nz-form-item>
      <ng-template #adAccountIdErrorTemplate let-control>
        <div *ngIf="adAccountIdFormControl?.errors?.['required']">Please enter the Ad Account ID.</div>
        <div *ngIf="adAccountIdFormControl?.errors?.['pattern']">Ad Account ID only accepts numeric values</div>
      </ng-template>
    </ng-container>

    <!-- Hashed META Container -->
    <ng-template #hashedMetaContainer>
      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="appId" class="nfl-form-label">App ID</nz-form-label>
        <div *ngTemplateOutlet="hashedTemplate"></div>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="appSecret" class="nfl-form-label">App Secret</nz-form-label>
        <div *ngTemplateOutlet="hashedTemplate"></div>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="appToken" class="nfl-form-label">App Access Token</nz-form-label>
        <div *ngTemplateOutlet="hashedTemplate"></div>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="adAccountId" class="nfl-form-label">Ad Account ID</nz-form-label>
        <div *ngTemplateOutlet="hashedTemplate"></div>
      </nz-form-item>
    </ng-template>
  </ng-container>

  <!-- S3 Channel Credentials - directly in parent form -->
  <ng-container *ngIf="activationChannelForm.get('channelType')?.value === 'S3'">
    <nz-form-item>
      <nz-form-label [nzRequired]="true" nzFor="bucketName" class="nfl-form-label">S3 Bucket Name</nz-form-label>
      <nz-form-control [nzErrorTip]="bucketNameErrorTemplate">
        <input
          nz-input
          id="bucketName"
          formControlName="bucketName"
          placeholder="S3 Bucket Name"
          [readonly]="isClientIdVerified"
          [ngClass]="{ 'readonly-input': isClientIdVerified }"
        />
      </nz-form-control>
    </nz-form-item>
    <ng-template #bucketNameErrorTemplate let-control>
      <div *ngIf="control?.errors?.['required']">Please enter the S3 Bucket Name.</div>
      <div *ngIf="control?.errors?.['pattern']">S3 Bucket Name must not contain spaces</div>
    </ng-template>

    <nz-form-item>
      <nz-form-label [nzRequired]="true" nzFor="awsRegion" class="nfl-form-label">AWS Region</nz-form-label>
      <nz-form-control [nzErrorTip]="awsRegionErrorTemplate">
        <input
          nz-input
          id="awsRegion"
          formControlName="awsRegion"
          placeholder="AWS Region"
          [readonly]="isClientIdVerified"
          [ngClass]="{ 'readonly-input': isClientIdVerified }"
        />
      </nz-form-control>
    </nz-form-item>
    <ng-template #awsRegionErrorTemplate let-control>
      <div *ngIf="control?.errors?.['required']">Please enter the AWS Region.</div>
      <div *ngIf="control?.errors?.['pattern']">Invalid AWS Region format. Should be like "us-east-1".</div>
    </ng-template>

    <nz-form-item>
      <nz-form-label [nzRequired]="true" nzFor="iamRoleArn" class="nfl-form-label">IAM Role ARN</nz-form-label>
      <nz-form-control [nzErrorTip]="iamRoleArnErrorTemplate">
        <input
          nz-input
          id="iamRoleArn"
          formControlName="iamRoleArn"
          placeholder="IAM Role ARN"
          [readonly]="isClientIdVerified"
          [ngClass]="{ 'readonly-input': isClientIdVerified }"
        />
      </nz-form-control>
    </nz-form-item>
    <ng-template #iamRoleArnErrorTemplate let-control>
      <div *ngIf="control?.errors?.['required']">Please enter the IAM Role ARN.</div>
      <div *ngIf="control?.errors?.['pattern']">
        Invalid IAM Role ARN format. Should be like "arn:aws:iam::123456789012:role/role-name".
      </div>
    </ng-template>
  </ng-container>

  <!-- Google Channel Credentials - with form control and form group -->
  <ng-container *ngIf="activationChannelForm.get('channelType')?.value === 'GOOGLE'">
    <ng-container formGroupName="channelSecrets" *ngIf="!channelId || isResetCredentials; else hashedGoogleContainer">
      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="oauthClientId" class="nfl-form-label">OAuth Client ID</nz-form-label>
        <nz-form-control [nzErrorTip]="oauthClientIdErrorTemplate">
          <nz-input-group [nzSuffix]="googleClientIdTemplate">
            <input
              nz-input
              id="oauthClientId"
              [type]="clientIdVisible ? 'text' : 'password'"
              formControlName="oauthClientId"
              placeholder="OAuth Client ID"
            />
          </nz-input-group>
          <ng-template #googleClientIdTemplate>
            <i
              nz-icon
              [nzType]="clientIdVisible ? 'eye-invisible' : 'eye'"
              (click)="clientIdVisible = !clientIdVisible"
            ></i>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <ng-template #oauthClientIdErrorTemplate let-control>
        <div *ngIf="oauthClientIdFormControl?.errors?.['required']">Please enter the OAuth client id.</div>
        <div *ngIf="oauthClientIdFormControl?.errors?.['pattern']">OAuth client id must not contain spaces</div>
      </ng-template>

      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="oauthClientSecret" class="nfl-form-label"
          >OAuth Client Secret</nz-form-label
        >
        <nz-form-control [nzErrorTip]="oauthClientSecretErrorTemplate">
          <nz-input-group [nzSuffix]="googleSecretTemplate">
            <input
              nz-input
              id="oauthClientSecret"
              [type]="secretVisible ? 'text' : 'password'"
              formControlName="oauthClientSecret"
              placeholder="OAuth Client Secret"
            />
          </nz-input-group>
          <ng-template #googleSecretTemplate>
            <i nz-icon [nzType]="secretVisible ? 'eye-invisible' : 'eye'" (click)="secretVisible = !secretVisible"></i>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <ng-template #oauthClientSecretErrorTemplate let-control>
        <div *ngIf="oauthClientSecretFormControl?.errors?.['required']">Please enter the OAuth client secret.</div>
        <div *ngIf="oauthClientSecretFormControl?.errors?.['pattern']">OAuth client secret must not contain spaces</div>
      </ng-template>

      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="refreshToken" class="nfl-form-label">Refresh Token</nz-form-label>
        <nz-form-control [nzErrorTip]="refreshTokenErrorTemplate">
          <nz-input-group [nzSuffix]="googleTokenTemplate">
            <textarea
              nz-input
              id="refreshToken"
              formControlName="refreshToken"
              placeholder="Refresh Token"
              [nzAutosize]="{ minRows: 2, maxRows: 6 }"
              maxlength="500"
              [class.masked]="!tokenVisible"
            ></textarea>
          </nz-input-group>
          <ng-template #googleTokenTemplate>
            <i nz-icon [nzType]="tokenVisible ? 'eye-invisible' : 'eye'" (click)="tokenVisible = !tokenVisible"></i>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <ng-template #refreshTokenErrorTemplate let-control>
        <div *ngIf="refreshTokenFormControl?.errors?.['required']">Please enter the refresh token.</div>
        <div *ngIf="refreshTokenFormControl?.errors?.['pattern']">Refresh token must not contain spaces</div>
      </ng-template>

      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="developerToken" class="nfl-form-label">Developer Token</nz-form-label>
        <nz-form-control [nzErrorTip]="developerTokenErrorTemplate">
          <nz-input-group [nzSuffix]="googleDevTokenTemplate">
            <input
              nz-input
              id="developerToken"
              [type]="developerTokenVisible ? 'text' : 'password'"
              formControlName="developerToken"
              placeholder="Developer Token"
            />
          </nz-input-group>
          <ng-template #googleDevTokenTemplate>
            <i
              nz-icon
              [nzType]="developerTokenVisible ? 'eye-invisible' : 'eye'"
              (click)="developerTokenVisible = !developerTokenVisible"
            ></i>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <ng-template #developerTokenErrorTemplate let-control>
        <div *ngIf="developerTokenFormControl?.errors?.['required']">Please enter the developer token.</div>
        <div *ngIf="developerTokenFormControl?.errors?.['pattern']">Developer token must not contain spaces</div>
      </ng-template>

      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="customerId" class="nfl-form-label">Customer ID</nz-form-label>
        <nz-form-control [nzErrorTip]="customerIdErrorTemplate">
          <input nz-input id="customerId" formControlName="customerId" placeholder="Customer ID" />
        </nz-form-control>
      </nz-form-item>
      <ng-template #customerIdErrorTemplate let-control>
        <div *ngIf="customerIdFormControl?.errors?.['required']">Please enter the customer id.</div>
        <div *ngIf="customerIdFormControl?.errors?.['pattern']">Customer id must be exactly 10 numeric digits</div>
      </ng-template>

      <nz-form-item>
        <nz-form-label [nzRequired]="false" nzFor="loginCustomerId" class="nfl-form-label"
          >Login Customer ID</nz-form-label
        >
        <nz-form-control [nzErrorTip]="loginCustomerIdErrorTemplate">
          <input nz-input id="loginCustomerId" formControlName="loginCustomerId" placeholder="Login Customer ID" />
        </nz-form-control>
      </nz-form-item>
      <ng-template #loginCustomerIdErrorTemplate let-control>
        <div *ngIf="loginCustomerIdFormControl?.errors?.['pattern']">Login customer id only accepts numeric values</div>
      </ng-template>
    </ng-container>

    <!-- Hashed Google Container -->
    <ng-template #hashedGoogleContainer>
      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="oauthClientId" class="nfl-form-label">OAuth Client ID</nz-form-label>
        <div *ngTemplateOutlet="hashedTemplate"></div>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="oauthClientSecret" class="nfl-form-label"
          >OAuth Client Secret</nz-form-label
        >
        <div *ngTemplateOutlet="hashedTemplate"></div>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="refreshToken" class="nfl-form-label">Refresh Token</nz-form-label>
        <div *ngTemplateOutlet="hashedTemplate"></div>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="developerToken" class="nfl-form-label">Developer Token</nz-form-label>
        <div *ngTemplateOutlet="hashedTemplate"></div>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="customerId" class="nfl-form-label">Customer ID</nz-form-label>
        <div *ngTemplateOutlet="hashedTemplate"></div>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="loginCustomerId" class="nfl-form-label">Login Customer ID</nz-form-label>
        <div *ngTemplateOutlet="hashedTemplate"></div>
      </nz-form-item>
    </ng-template>
  </ng-container>

  <ng-container *ngIf="isClientIdVerified">
    <span nz-icon nzType="check-square" nzTheme="twotone" [nzTwotoneColor]="iconColorCode"></span>
    <span nz-typography class="nfl-form-label connection-text">Connection Tested Successfully</span>
  </ng-container>

  <!-- Button wrapper -->
  <div nz-row>
    <nz-form-item class="w100 button-row">
      <nz-space nzSize="middle">
        <button
          *nzSpaceItem
          nz-button
          nzType="text"
          [nzLoading]="spinningState === 'reset'"
          nzOutline
          (click)="resetCredentials()"
        >
          Reset Credentials
        </button>
        <button
          *nzSpaceItem
          nz-button
          nzType="default"
          [nzLoading]="spinningState === 'test'"
          [disabled]="activationChannelForm.invalid || !isResetCredentials"
          nzOutline
          (click)="getUserAccessToken()"
        >
          Test
        </button>

        <button
          *nzSpaceItem
          nz-button
          nzType="primary"
          [nzLoading]="spinningState === 'create'"
          [disabled]="!isClientIdVerified || activationChannelForm.invalid"
          (click)="channelId ? handleUpdate() : handleSave()"
        >
          {{ channelId ? 'Update' : 'Create' }}
        </button>
      </nz-space>
    </nz-form-item>
  </div>

  <!-- Template to show for hashed item -->
  <ng-template #hashedTemplate>
    <nz-form-control> ******************* </nz-form-control>
  </ng-template>
</form>
